import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from '@resurs/midas-react'
import confirmDialogConfirmIcon from '../../assets/img/confirm-dialog-confirm-icon.svg'
import confirmDialogDestructiveIcon from '../../assets/img/confirm-dialog-destructive-icon.svg'
import { getText } from '../../internal/TextLabels'

import styles from './ConfirmDialog.module.scss'

const ConfirmDialog = ({
  show,
  destructive,
  title,
  text,
  action,
  onClose,
  onConfirm,
}) => (
  <div className={styles.container}>
    <Modal show={show} onClose={onClose}>
      <div className={styles.content}>
        <img
          alt=""
          className={styles.icon}
          src={
            destructive
              ? confirmDialogDestructiveIcon
              : confirmDialogConfirmIcon
          }
        />
        <div className={styles.main}>
          <h4>{title}</h4>
          {text}
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          id="confirm-dialog-cancel"
          type="normal"
          kind="normal"
          size="normal"
          onClick={onClose}
        >
          {getText('default.cancel')}
        </Button>
        <Button
          id="confirm-dialog-confirm"
          type="primary"
          kind={destructive ? 'danger' : 'normal'}
          size="normal"
          onClick={onConfirm}
        >
          {action}
        </Button>
      </div>
    </Modal>
  </div>
)

ConfirmDialog.propTypes = {
  show: PropTypes.bool,
  destructive: PropTypes.bool,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
}

ConfirmDialog.defaultProps = {
  show: false,
  destructive: false,
  onClose: () => undefined,
  onConfirm: () => undefined,
}

export default ConfirmDialog
